module.exports = __webpack_public_path__ + "img/eye-off.232e5a7d.svg";